export default __webpack_public_path__ + "static/frankula-UI-a6d404a15eef5ba34265e8ff806f83ab.mp4";